import React, { useState } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import { StepProps } from '../createStateMachine';
import { RemoteInstallFormContext } from '../index';
import css from '../index.module.scss';
import { useLang } from '@/i18n';

const Step5: React.FC<StepProps<RemoteInstallFormContext>> = ({ send, context }) => {
    const { t } = useLang('questionnaire');
    const [selected, setSelected] = useState(context.step5);
    const handleChange = (e) => {
        setSelected(e.target.value as any);
    };
    return (
        <div className={css.step}>
            <div className="step-head">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1766458160480/pc_shp2.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1766458160670/m_shp2.jpg"
                />
                <span>{t('step_head')}</span>
            </div>
            <div className="step-info">
                <div className="step-title">
                    <span>*</span>
                    {t('step5_question')}
                </div>
                <label className="step-radio">
                    <input type="radio" name="step" value="has" checked={selected === 'has'} onChange={handleChange} />
                    <span>{t('step5_item1')}</span>
                </label>
                <label className="step-radio">
                    <input type="radio" name="step" value="only" checked={selected === 'only'} onChange={handleChange} />
                    <span>{t('step5_item2')}</span>
                </label>
                <label className="step-radio">
                    <input type="radio" name="step" value="not" checked={selected === 'not'} onChange={handleChange} />
                    <span>{t('step5_item3')}</span>
                </label>
            </div>
            <div className="step-btns">
                <button className="step-btn step-btn-prev" onClick={() => send('BACK')}>
                    {t('btn1')}
                </button>
                <button
                    className={`step-btn step-btn-next ${!selected ? 'step-btn-disabled' : ''}`}
                    onClick={() => {
                        if (!selected) return;
                        send(selected);
                    }}
                >
                    {t('btn2')}
                </button>
            </div>
        </div>
    );
};
export default Step5;
